// src/app/guards/auth.guard.ts
import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { UserService } from '../../services/user-service/user.service';

@Injectable({
  providedIn: 'root'
})
export class UserGuard implements CanActivate {
  constructor(
    private router: Router,
    private userService: UserService
  ) {}

  canActivate(): boolean {
    let state = this.userService.getUserState();
    console.log(state);
    // this.router.navigate(['/']);
    return state.isAuthenticated;
  }
}
